module.exports = __webpack_public_path__ + "static/media/mobile.dd776417.svg";